/* eslint-disable @next/next/no-img-element */
import logoIcon from "../assets/logo.svg";

export function Logo({
  className = "tw:object-contain tw:block tw:w-14",
}: {
  className?: string;
}) {
  return <img src={logoIcon} alt="Social Ocean Logo" className={className} />;
}
